export default __webpack_public_path__ + "static/media/pngLetraNegraRedimensionado.6589bd68.png";